/**
 * RFST — Collection & search filtering
 * Submits the native Shopify filter form via the Section Rendering API so the
 * product grid updates without a full page reload. Falls back to normal form
 * submission when JavaScript is unavailable (see the <noscript> button).
 */
(function () {
  'use strict';

  var form = document.querySelector('[data-facets-form]');
  var gridContainer = document.querySelector('[data-product-grid-container]');
  if (!form || !gridContainer) return;

  var debounceTimer = null;

  function getSectionId() {
    var section = document.querySelector('[data-collection-section], [data-search-section]');
    if (!section) return null;
    var wrapper = section.closest('.shopify-section');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
  }

  function buildUrl() {
    var params = new URLSearchParams(new FormData(form));

    // Drop empty values so the URL stays clean and shareable.
    var cleaned = new URLSearchParams();
    params.forEach(function (value, key) {
      if (value !== '') cleaned.append(key, value);
    });

    var base = window.location.pathname;
    var query = cleaned.toString();
    return query ? base + '?' + query : base;
  }

  function renderFromUrl(targetUrl, updateHistory) {
    var sectionId = getSectionId();
    if (!sectionId) return;

    var separator = targetUrl.indexOf('?') > -1 ? '&' : '?';
    gridContainer.setAttribute('aria-busy', 'true');

    fetch(targetUrl + separator + 'section_id=' + sectionId)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = parsed.querySelector('[data-product-grid-container]');
        if (newGrid) gridContainer.innerHTML = newGrid.innerHTML;

        var newForm = parsed.querySelector('[data-facets-form]');
        var currentForm = document.querySelector('[data-facets-form]');
        if (newForm && currentForm) currentForm.innerHTML = newForm.innerHTML;

        var newCount = parsed.querySelector('.collection-page__count, .search-page__count');
        var currentCount = document.querySelector('.collection-page__count, .search-page__count');
        if (newCount && currentCount) currentCount.innerHTML = newCount.innerHTML;

        if (updateHistory !== false) {
          window.history.pushState({ facets: targetUrl }, '', targetUrl);
        }
      })
      .catch(function () {
        // On failure, fall back to a normal navigation.
        window.location.href = targetUrl;
      })
      .finally(function () {
        gridContainer.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest('[data-facets-form]')) return;
    renderFromUrl(buildUrl());
  });

  document.addEventListener('input', function (event) {
    var priceInput = event.target.closest('.facets__price-range input');
    if (!priceInput) return;

    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () {
      renderFromUrl(buildUrl());
    }, 600);
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.closest('[data-facets-form]')) return;
    event.preventDefault();
    renderFromUrl(buildUrl());
  });

  document.addEventListener('click', function (event) {
    var clear = event.target.closest('[data-facets-clear]');
    if (clear) {
      event.preventDefault();
      renderFromUrl(clear.getAttribute('href'));
      return;
    }

    // Paginate without a full reload.
    var pageLink = event.target.closest('.pagination__item[href]');
    if (pageLink) {
      event.preventDefault();
      renderFromUrl(pageLink.getAttribute('href'));
      window.scrollTo({ top: gridContainer.offsetTop - 100, behavior: 'smooth' });
    }
  });

  window.addEventListener('popstate', function () {
    renderFromUrl(window.location.pathname + window.location.search, false);
  });

  /* -------------------------------------------------- *
   * Mobile filter drawer
   * -------------------------------------------------- */

  var sidebar = document.querySelector('[data-facets-sidebar]');
  var overlay = document.querySelector('[data-facets-overlay]');

  function openFacets() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('overflow-hidden');
  }

  function closeFacets() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-facets-open]')) {
      event.preventDefault();
      openFacets();
    } else if (event.target.closest('[data-facets-close]') || event.target.closest('[data-facets-overlay]')) {
      event.preventDefault();
      closeFacets();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeFacets();
  });
})();
